import React from "react";
import { Link, Route } from "react-router-dom";

import NotFound from "../components/NotFound";
import RequireAuth from "../components/RequireAuth";
import { AUTH_LEVELS } from "../lib/globals";
import SettingsLoader from "../loaders/SettingsLoader";
import DateSettings from "../pages/SiteManagement/DateSettings";
import DisplaySettings from "../pages/SiteManagement/DisplaySettings";
import SiteManagementIndex, {
    loader as IndexLoader,
} from "../pages/SiteManagement/Index";
import SiteManagementLayout from "../pages/SiteManagement/Layout";
import PageContent from "../pages/SiteManagement/PageContent";
import PhotoApproval, {
    loader as PhotoApprovalLoader,
} from "../pages/SiteManagement/PhotoApproval";
import RosterSettings from "../pages/SiteManagement/RosterSettings";
import RulesSettings, {
    loader as RulesLoader,
} from "../pages/SiteManagement/RulesSettings";
import SiteNotice, {
    loader as NoticesLoader,
} from "../pages/SiteManagement/SiteNotice";
import TermsConditions from "../pages/SiteManagement/TermsConditions";
import UmpirePaySettings from "../pages/SiteManagement/UmpirePaySettings";
import Users from "../pages/SiteManagement/Users";
import UsersLoader from "../pages/SiteManagement/Users/loaders/usersLoader";
import WaiverText from "../pages/SiteManagement/Waiver";

export default (
    <Route
        element={<RequireAuth allowedUserLevels={AUTH_LEVELS.sitemanagement} />}
    >
        <Route
            path="site-management"
            handle={{
                crumb: () => <Link to="/site-management">Site Management</Link>,
            }}
            element={<SiteManagementLayout />}
        >
            <Route
                index
                element={<SiteManagementIndex />}
                loader={IndexLoader}
                handle={{
                    header: () => "Site Management",
                }}
            />
            <Route path="settings">
                <Route
                    path="date"
                    element={<DateSettings />}
                    loader={SettingsLoader}
                    handle={{
                        crumb: () => {
                            return (
                                <Link to={`/site-management/settings/date`}>
                                    Date Settings
                                </Link>
                            );
                        },
                        header: () => "Date Settings",
                    }}
                />
                <Route
                    path="roster"
                    element={<RosterSettings />}
                    loader={SettingsLoader}
                    handle={{
                        crumb: () => {
                            return (
                                <Link to={`/site-management/settings/roster`}>
                                    Roster Settings
                                </Link>
                            );
                        },
                        header: () => "Roster Settings",
                    }}
                />
                <Route
                    path="display"
                    element={<DisplaySettings />}
                    loader={SettingsLoader}
                    handle={{
                        crumb: () => {
                            return (
                                <Link to={`/site-management/settings/display`}>
                                    Display Settings
                                </Link>
                            );
                        },
                        header: () => "Display Settings",
                    }}
                />
                <Route
                    path="notice"
                    element={<SiteNotice />}
                    loader={NoticesLoader}
                    handle={{
                        crumb: () => {
                            return (
                                <Link to={`/site-management/settings/notice`}>
                                    Site Notice
                                </Link>
                            );
                        },
                        header: () => "Site Notice",
                    }}
                />
            </Route>
            <Route
                path="content"
                element={<PageContent />}
                loader={SettingsLoader}
                handle={{
                    crumb: () => {
                        return (
                            <Link to={`/site-management/content`}>
                                Page Content
                            </Link>
                        );
                    },
                    header: () => "Page Content",
                }}
            />
            <Route
                path="content/waiver"
                element={<WaiverText />}
                loader={SettingsLoader}
                handle={{
                    crumb: () => {
                        return (
                            <Link to={`/site-management/content/waiver`}>
                                Waiver Text
                            </Link>
                        );
                    },
                    header: () => "Waiver Text",
                }}
            />
            <Route
                path="content/terms-and-conditions"
                element={<TermsConditions />}
                loader={SettingsLoader}
                handle={{
                    crumb: () => {
                        return (
                            <Link
                                to={`/site-management/content/terms-and-conditions`}
                            >
                                Terms & Conditions
                            </Link>
                        );
                    },
                    header: () => "Terms & Conditions",
                }}
            />
            <Route
                path="umpirepay"
                element={<UmpirePaySettings />}
                loader={SettingsLoader}
                handle={{
                    crumb: () => {
                        return (
                            <Link to={`/site-management/umpirepay`}>
                                Umpire Pay
                            </Link>
                        );
                    },
                    header: () => "Umpire Pay",
                }}
            />
            <Route
                path="photoApproval"
                element={<PhotoApproval />}
                loader={PhotoApprovalLoader}
                handle={{
                    crumb: () => {
                        return (
                            <Link to={`/site-management/photoApproval`}>
                                Photo Approvals
                            </Link>
                        );
                    },
                    header: () => "Photo Approvals",
                }}
            />
            <Route
                path="rules"
                element={<RulesSettings />}
                loader={RulesLoader}
                handle={{
                    crumb: () => (
                        <Link to="/site-management/rules">
                            Tournament Rules
                        </Link>
                    ),
                    header: () => "Tournament Rules",
                }}
            />
            <Route
                path="users"
                element={<Users />}
                loader={UsersLoader}
                handle={{
                    crumb: () => (
                        <Link to="/site-management/users">User Management</Link>
                    ),
                    header: () => "User Management",
                }}
            />
            <Route
                path="*"
                element={<NotFound parent="sitemanagement" />}
                handle={{ header: () => "Site Management Page Not Found" }}
            />
        </Route>
    </Route>
);
